import { actions, getContentEntityStructuresLookupsAsync } from './slices';

export const ContentEntityStructuresActions = {
  ...actions,
  getContentEntityStructuresLookupsAsync,
};

export * from './thunkHandlers';
